<template>
  <div v-html="content"></div>
</template>

<script>
export default {
  name: "HistoricalEventDetails",
  data() {
    return {
      content: null
    }
  },
  mounted() {
    if (this.$route.params.content !== undefined) {
      this.content = this.$route.params.content
    } else {
      this.$router.go(-1)
    }
  },
  methods: {}
}
</script>

<style scoped>

</style>
